import { BarChart } from "@jana-technology/platform-ui";

import { ChartCard, MajorEventRiskComparison } from "components/charts";
import { useGlobalFiltersContext } from "contexts/filters";
import { xAccessor } from "helpers/charts";
import { useMajorRiskCharts } from "hooks/queries";
import { useBaseBarChartProps } from "hooks/useBaseBarChartProps";
import { ChartsLayout } from "layouts/ChartsLayout";

export const RiskManagementMajorRiskCharts = () => {
  const { appliedWell } = useGlobalFiltersContext();

  const [hierarchyId, wellName] = appliedWell;

  const {
    majorRiskByConsequenceSeries,
    majorRiskByThreatSeries,
    majorRiskDataKeys,
    majorRiskChartsQueryResult,
  } = useMajorRiskCharts({
    skip: !wellName.length,
    variables: {
      hierarchyId,
      wellName,
    },
  });

  const baseBarChartProps = useBaseBarChartProps();

  return (
    <ChartsLayout>
      <ChartCard
        loading={majorRiskChartsQueryResult.loading}
        heading="Risk by Threat"
      >
        <BarChart
          {...baseBarChartProps}
          withBarLabels
          xAxisLabel="Threat"
          yAxisLabel="Major Event Risk"
          chartName="Risk by Threat"
          xAccessor={xAccessor}
          data={majorRiskByThreatSeries}
          dataKeys={majorRiskDataKeys}
          barWidth={32}
        />
      </ChartCard>
      <ChartCard
        loading={majorRiskChartsQueryResult.loading}
        heading="Risk by Consequence"
      >
        <BarChart
          {...baseBarChartProps}
          withBarLabels
          xAxisLabel="Consequence"
          yAxisLabel="Major Event Risk"
          chartName="Risk by Consequence"
          xAccessor={xAccessor}
          data={majorRiskByConsequenceSeries}
          dataKeys={majorRiskDataKeys}
        />
      </ChartCard>
      <MajorEventRiskComparison />
    </ChartsLayout>
  );
};

export default RiskManagementMajorRiskCharts;
